import { Component, OnInit, Input } from '@angular/core';
import { Area } from '../area.interface';
import { AuthService } from '../../../auth/auth.service';
import { AreaService } from '../area.service';
import { AreaOptionsAction } from './area-options.interface';
import { ModalService } from '../../../services/modal/modal.service';

@Component({
  selector: 'sg2-area-options',
  templateUrl: './area-options.component.html',
  styleUrls: ['./area-options.component.less']
})
export class AreaOptionsComponent implements OnInit {

  /** Default options. */
  private readonly OPTIONS_DEFAULT: AreaOptionsAction['action'][] = ['delete', 'edit'];

  /** Area. */
  @Input() area: Area;

  /** Disabled state of menu. */
  @Input() disabled: boolean;

  /** Set custom selection of options. */
  @Input() options: string[];

  /** Configuration. */
  public config: {
    delete?: boolean;
    edit?: boolean;
  } = { };

  constructor(
    private areaService: AreaService,
    public authService: AuthService,
    private modalService: ModalService
  ) { }

  ngOnInit() {
    this._setOptions();
  }

  /**
   * Delete area.
   *
   * @param area The area to delete.
   */
  public delete(area: Area): void {
    this.areaService.delete(area, true);
  }

  /**
   * Edit area.
   *
   * @todo Open create/edit area modal or sidebar.
   *
   * @param area The area to edit.
   */
  public edit(area: Area): void {
    console.log('open edit modal');
  }

  /**
   * Set menu options.
   *
   * A custom selection of options can be added by using the options binding.
   * When no options are given, the default selection is used.
   */
  private _setOptions(): void {
    this.options = this.options || this.OPTIONS_DEFAULT;
    this.options.forEach(o => {
      this.config[o] = true;
    });
  }
}
